import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class AsyncApplyForm extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    routeApplyHistory: PropTypes.func.isRequired,
    runInBackground: PropTypes.func.isRequired,
    // extraAction is close modal action, used in no-react environment
    extraAction: PropTypes.func,
  };

  static defaultProps = {
    extraAction: () => {},
  };

  routeApplyHistory = () => {
    this.props.routeApplyHistory();
    this.props.extraAction();
  };

  runInBackground = () => {
    this.props.runInBackground();
    this.props.extraAction();
  };

  render() {
    const {
      i18n,
    } = this.props;
    const applyHistoryLink = (
      <button
        className="recommendation-apply-history btn-link"
        onClick={this.routeApplyHistory}
      >
        {i18n.getString('Recommendation_Async_Route_To_History')}
      </button>
    );

    return (
      <div
        className="recommendation-async-apply-form"
      >
        <button
          className={classNames('close', 'closeimage')}
          onClick={this.runInBackground}
          aria-label={i18n.getString('Button_Close')}
        />
        <h3 className="recommendation-async-apply-title">
          <span className="blocker">
            <span className="blocker-indicator">
              <span className="blocker-image" />
            </span>
          </span>
          <span>{i18n.getString('Recommendation_Async_Apply_Title')}</span>
        </h3>
        <div className="recommendation-async-apply-actions">
          <span>{i18n.getString('Recommendation_Async_Apply_Choices_Prefix')}</span>
        </div>
        <div>
          {applyHistoryLink}
        </div>
      </div>
    );
  }
}
